const charStylesMessage = {
  type: 'preset',
  tag: 'p',
  content: '{~?~The following paragraph contains all of the character styles used in this document:}'
};

const specialCharsMessage = {
  type: 'preset',
  tag: 'p',
  content: '{~?~The following paragraph contains all of the special characters used in this document, separated by pipes:}'
};

export default class SampleConfiguration {
  constructor(elements, characterStyles, specialCharacters) {
    this.elements = elements;
    this.characterStyles = characterStyles;
    this.specialCharacters = specialCharacters;
    this.config = [];
  }

  toArray() {
    this.config = this.basicElementMap();
    this.config.push(charStylesMessage);
    this.config.push(this.formattedCharStyles());
    this.config.push(specialCharsMessage);
    this.config.push(this.formattedSpecialChars());
    this.config.push({type: 'note', format: 'fn'});
    this.config.push({type: 'note', format: 'en'});
    return this.config;
  }

  basicElementMap() {
    return this.elements.map((element) => {
      return {
        type: 'exists',
        selector: element
      };
    });
  }

  formattedCharStyles() {
    return {
      type: 'charstyles',
      tag: 'p',
      content: 'word',
      children: this.characterStyles.slice(),
    };
  }

  formattedSpecialChars() {
    return {
      type: 'preset',
      tag: 'p',
      content: this.specialCharacters.slice().join(' | '),
    };
  }
}
